export default __webpack_public_path__ + "static/media/worksheet-pending-icon.96183c90.png";